<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="back-container">
        <div class="back" (click)="routeBack()" style="cursor: pointer;">
            <img src="assets/back_icon.svg" /> Back
        </div>
    </div>

    <div class="header desktop-header">
        <div class="header_content">
            <div class="header-title">
                Customer Name
            </div>
            <div class="header-value">
                {{ customer_name || '-' }}
            </div>
        </div>
        <div class="header_content">
            <div class="header-title">
                Customer Location
            </div>
            <div class="header-value">
                {{ customer_location || '-' }}
            </div>
        </div>
        <div class="header_content" *ngIf="!isCement">
            <div class="header-title">
                Materials
            </div>
            <div class="header-value">
                {{ materialName || '-' }}
            </div>
        </div>
        <div class="header_content" *ngIf="isCement">
            <div class="header-title">
                Materials / Vehicle Type
            </div>
            <div class="header-value">
                {{ materialName || '-' }} / {{ vehicleTypeCement || '-' }}
            </div>
        </div>
        <div class="header_content">
            <div class="header-title">
                Accepted Quantity
            </div>
            <div class="header-value">
                {{ accepted_quantity || '-' }} MT
            </div>
        </div>
        <div class="header_content">
            <div class="header-title">
                LIN No.
            </div>
            <div class="header-value">
                {{ lin_number || '-' }}
            </div>
        </div>
    </div>

    <div class="mobile-header-container">
        <div class="mobile-header-toggle" (click)="toggleMobileHeader()">
            <span>Customer Details</span>
            <span class="toggle-icon">{{ isMobileHeaderCollapsed ? '▼' : '▲' }}</span>
        </div>

        <div class="mobile-header" [ngClass]="{'collapsed': isMobileHeaderCollapsed}">
            <div class="mobile-header-item">
                <div class="header-title">Customer Name</div>
                <div class="header-value">{{ customer_name || '-' }}</div>
            </div>
            <div class="mobile-header-item">
                <div class="header-title">Customer Location</div>
                <div class="header-value">{{ customer_location || '-' }}</div>
            </div>
            <div class="mobile-header-item" *ngIf="!isCement">
                <div class="header-title">Materials</div>
                <div class="header-value">{{ materialName || '-' }}</div>
            </div>
            <div class="mobile-header-item" *ngIf="isCement">
                <div class="header-title">Materials / Vehicle Type</div>
                <div class="header-value">{{ materialName || '-' }} / {{ vehicleTypeCement || '-' }}</div>
            </div>
            <div class="mobile-header-item">
                <div class="header-title">Accepted Quantity</div>
                <div class="header-value">{{ accepted_quantity || '-' }} MT</div>
            </div>
            <div class="mobile-header-item">
                <div class="header-title">LIN No.</div>
                <div class="header-value">{{ lin_number || '-' }}</div>
            </div>
        </div>
    </div>

    <div class="section">
        <div class="body">
            <div class="search_section" *ngIf="driverImage">
                <div class="search_section_content">
                </div>
                <div class="search_section_content">
                </div>
                <div class="search_section_content">
                    <div>
                        <div class="driver-image">
                            <img [src]="driverImage" alt="vehicle"
                                style="width: 72px; height: 72px; border-radius: 5px;" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="search_section">
                <div class="search_section_content">
                    <div class="left_search">
                        <div class="input-container" style="margin-bottom: 15px;">
                            <div class="label">
                                {{ "SPOT.vehicle_search" | translate }}
                                <span></span>
                            </div>
                            <input type="text" class="inputSelect" autocomplete="off" [(ngModel)]="vehicle_number" />
                            <div class="tick" *ngIf="is_vehicle_verified">
                                <img src="assets/tick.svg" width="20" height="20" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="right_search">
                        <div class="search_btn" (click)="searchVehicleDetails()">
                            Verify
                        </div>
                    </div>
                </div>
                <div class="search_section_content">
                    <div class="left_search" style="width: 100%;">
                        <div class="input-container" style="margin-bottom: 15px;">
                            <div class="label">
                                {{ "SPOT.license" | translate }}
                                <sup style="color: #e54131; font-weight: 900">*</sup>
                            </div>
                            <input class="inputSelect" [(ngModel)]="spotVehicleData.driver_licence_no" type="text"
                                autocomplete="off" />
                        </div>
                    </div>
                </div>
                <div class="search_section_content">
                    <div class="left_search">
                        <div class="input-container" style="margin-bottom: 15px;">
                            <div class="label">
                                {{ "SPOT.driverDob" | translate
                                }}<span><sup style="color: #ff0000">*</sup></span>
                            </div>
                            <div class="formInput" style="width: 100%;">
                                <input class="inputSelect" type="text" name="driverDob" [matDatepicker]="dobpicker"
                                    [(ngModel)]="driverDob" (click)="dobpicker.open()" autocomplete="off" />
                                <mat-datepicker #dobpicker></mat-datepicker>
                            </div>
                            <div class="tick" *ngIf="is_driver_verified">
                                <img src="assets/tick.svg" width="20" height="20" alt="" />
                                <span>{{'SPOT.verified' | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="right_search">
                        <div class="search_btn" (click)="verifyDriver()">Verify</div>
                    </div>
                </div>
            </div>

            <div class="left">
                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.driverName' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.name">
                    <div class="check" style="height: 0px;">
                        <mat-checkbox style="font-size: 12px;width: 15px;height: 15px;"
                            [(ngModel)]='spotVehicleData.has_smart_phone'>{{'SPOT.hasSmartPhone' |
                            translate}}</mat-checkbox>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.mobileNum' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.mobile">
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.driverType' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField"
                            style="height: 21px;background-color: #fff;border: solid 1px #e3e3e3; border-radius: 5px; padding: 4px;width:100%"
                            [(ngModel)]="spotVehicleData.driver_type">
                            <mat-option *ngFor="let type of driverTypes" [value]="type.value"
                                (click)="selectDriverType(type.value)">
                                {{type.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.vehicleNum' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div *ngIf="spotVehicleData.vehicle_number">
                        {{spotVehicleData.vehicle_number}}
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.vehicleType' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField"
                            style="height: 21px;background-color: #fff;border: solid 1px #e3e3e3; border-radius: 5px; padding: 4px;width:100%"
                            [(ngModel)]="selectedVehicle">
                            <input
                                style="width:90%;height: 24px;outline: none;margin: 10px;border: solid 1px #e3e3e3;border-radius: 4px;"
                                (keyup)="applyVehicleTypeSearch($event.target.value)" type="text" class="inputSelect"
                                autocomplete="off" [(ngModel)]="searcheReg_for" placeholder="Search" />
                            <mat-option *ngFor="let vehicle of searchedVehicleType" [value]="vehicle.value">
                                {{ vehicle.viewValue }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.owner_name' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.owner_name">
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.owner_mobile_name' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.owner_mobile">
                </div>

                <div style="display:inline-flex;" *ngIf="spinner">
                    <span>
                        <mat-spinner [diameter]="20" style="position: relative;top: 30px;"></mat-spinner>
                    </span>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.vehicle_qty' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup> (MT)
                    </div>
                    <input [disabled]="vehicle_qty ? false : true" [(ngModel)]="capacityData.vehicle_qty"
                        (keyup)="sub($event.target.value)" type="text" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.rc_Laden_weight' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
                        (MT)
                    </div>
                    <input [disabled]="rc_Laden_weight ? false : true" [(ngModel)]="capacityData.rc_Laden_weight"
                        (keyup)="sub($event.target.value)" type="text" autocomplete="off" />
                </div>

                <div class="formElement" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
                    <div class="formLabel">
                        {{'ADD_VEHICLE.asset' | translate}}
                    </div>
                    <div class="formInput">
                        <input class="form-input" type="text" (keyup)="applyFilter($event.target.value)"
                            [matAutocomplete]="auto_assets" [(ngModel)]="selectedAsset">
                        <mat-autocomplete #auto_assets="matAutocomplete">
                            <mat-option *ngFor="let asset of assets" [value]="asset.reg_number"
                                (click)="selectAsset(asset)">
                                <span>
                                    {{asset.reg_number}}
                                </span>
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "SPOT.load_qty" | translate }}<sup style="color: #E54131; font-weight: 900;">*</sup>
                        (MT)
                    </div>
                    <input [(ngModel)]="capacityData.capacity" type="text" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "SPOT.desired_weight" | translate }}<sup style="color: #E54131; font-weight: 900;">*</sup>
                        (MT)
                    </div>
                    <input [(ngModel)]="capacityData.desired_weight" type="text" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.licenseExpiryDate' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="expiryDate" [matDatepicker]="picker" [(ngModel)]="expiryDate"
                            (click)="picker.open()" />
                        <mat-datepicker #picker
                            (closed)="setExpiryDate(expiryDate, 'change','licence_expiry')"></mat-datepicker>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "SPOT.insuranceno" | translate
                        }}
                    </div>
                    <input type="text" [(ngModel)]="insurance.no" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.insuranceexpirydate' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
                    </div>
                    <div class="formInput">
                        <input type="text" name="invExpiryDate" [matDatepicker]="insuPicker"
                            [(ngModel)]="insurance.expiry" (click)="insuPicker.open()"
                            (closed)="setExpiryDate(expiryDate, 'change','invExpiry')" autocomplete="off" />
                        <mat-datepicker #insuPicker></mat-datepicker>
                    </div>
                </div>

                <div class="inputContainer" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
                    <div class="label">
                        {{'SPOT.asset' | translate}}
                    </div>
                    <input type="text" (keyup)="applyFilter($event.target.value)" [matAutocomplete]="auto_assets"
                        [(ngModel)]="selectedAsset">
                    <mat-autocomplete #auto_assets="matAutocomplete">
                        <mat-option *ngFor="let asset of assets" [value]="asset.reg_number"
                            (click)="selectAsset(asset)">
                            <span>
                                {{asset.reg_number}}
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{ "SPOT.engineno" | translate
                        }}
                    </div>
                    <input type="text" [(ngModel)]="spotVehicleData.engine_number" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.chassisno' | translate}}
                    </div>
                    <input [(ngModel)]="spotVehicleData.chassis_number" type="text" />
                </div>

                <div class="inputContainer">
                    <div class="label">
                        No. of Diesel tank
                    </div>
                    <div class="input_dropdown">
                        <mat-select class="inputField"
                            style="height: 21px;background-color: #fff;border: solid 1px #e3e3e3; border-radius: 5px; padding: 4px;width:100%"
                            [(ngModel)]="engine_type">
                            <mat-option *ngFor="let type of diesel_tanks" [value]="type">
                                {{type}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="tanks" *ngIf="engine_type == 'Double'">
                        <div class="tank1">
                            <div class="label">
                                {{'Tank One Capacity (Litre)' | translate}}
                            </div>
                            <input type="text" [(ngModel)]="diesel_tank1" />
                        </div>
                        <div class="tank1">
                            <div class="label">
                                {{'Tank Two Capacity (Litre)' | translate}}
                            </div>
                            <input type="text" [(ngModel)]="diesel_tank2" />
                        </div>
                    </div>
                    <div class="tank" *ngIf="engine_type == 'Single'">
                        <div class="tank1">
                            <div class="label">
                                {{'Tank One Capacity (Litre)' | translate}}
                            </div>
                            <input type="text" [(ngModel)]="diesel_tank1" />
                        </div>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.Accessories' | translate }}
                    </div>
                    <div class="dialog_body">
                        <mat-select
                            style="border: solid 1px #e3e3e3;height: 21px;  border-radius: 5px;   align-items: center; padding: 5px;"
                            class="inputSelect" [(ngModel)]="spotVehicleData.tools" name="accessories">
                            <mat-option *ngFor="let acces of accessories" [value]="acces">
                                {{acces}}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.labour' | translate }}
                    </div>
                    <div class="dialog_body">
                        <mat-select
                            style="border: solid 1px #e3e3e3;height: 21px;  border-radius: 5px;   align-items: center;"
                            class="inputSelect" [(ngModel)]="spotVehicleData.labour" name="labour">
                            <mat-option *ngFor="let labor of labourCount" [value]="labor">
                                {{labor}}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.gps_provider' | translate}}
                    </div>
                    <mat-select class="inputSelect"
                        style="border: solid 1px #e3e3e3;padding: 5px;border-radius: 5px;align-items: center; width: 100%; height: 21px;"
                        [(ngModel)]="selectedGPSProvider">
                        <mat-option *ngFor="let provider of gps_providers" [value]="provider.value">
                            {{provider.name}}
                        </mat-option>
                    </mat-select>
                    <div class="addBtn" style="display:flex; justify-content: space-between;padding-top: 10px;">
                        <div class="add_btn" *ngIf="selectedGPSProvider" (click)="removeGps();">
                            <div class="button">
                                {{'SPOT.remove' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.pos' | translate}}
                    </div>
                    <mat-select class="inputSelect"
                        style="border: solid 1px #e3e3e3;padding: 5px;border-radius: 5px;align-items: center; width: 100%; height: 21px;"
                        [(ngModel)]="selectedPos">
                        <mat-option *ngFor="let state of states" [value]="state.name">
                            {{state.name}}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="inputContainer">
                    <div class="label">
                        {{'SPOT.remarks' | translate}}
                    </div>
                    <input [(ngModel)]="remarks" type="text" />
                </div>

                <div class="inputContainer" *ngIf="showMonthlySubscription">
                    <div class="label">
                        {{ 'SPOT.monthlySubscription' | translate }}
                    </div>
                    <mat-radio-group [(ngModel)]="monthlySubscription">
                        <mat-radio-button [value]="true" style="margin-right: 12px;">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="inputContainer" style="display: flex; align-items: center; margin-top: 16px;">
                    <input type="checkbox" [(ngModel)]="spotVehicleData.is_dedicated_vehicle"
                        style=" width: 16px; cursor: pointer;">
                    <div class="label" style="padding-left: 6px">
                        Is it Dedicated Vehicle?
                    </div>
                </div>
            </div>
            <div class="fixed-bottom-buttons">
                <div class="submit_btns">
                    <div class="add_btn" (click)="addOwnVehicle();">
                        <div class="button">
                            {{'SPOT.add' | translate}}
                        </div>
                    </div>

                    <div class="delete_btn" *ngIf="messageDeleteStatus" (click)="deleteSpot()">
                        <div class="button">
                            {{'SPOT.delete' | translate}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>